import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "card h-100 text-center w-100 border-dark" }
const _hoisted_2 = {
  class: "card-header d-flex flex-row align-items-center justify-content-center p-1 bg-dark text-white",
  style: {"min-height":"3rem"}
}
const _hoisted_3 = { class: "my-0 mx-4" }
const _hoisted_4 = { class: "dropdown d-inline-flex mx-4" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn btn-secondary btn-block",
  "data-bs-toggle": "dropdown"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "bi bi-plus-circle" })
], -1)
const _hoisted_6 = {
  tabindex: "-1",
  class: "dropdown-menu"
}
const _hoisted_7 = {
  href: "#",
  target: "_self",
  class: "dropdown-item"
}
const _hoisted_8 = {
  href: "#",
  target: "_self",
  class: "dropdown-item"
}
const _hoisted_9 = {
  key: 0,
  class: "card-body p-1"
}
const _hoisted_10 = { class: "mh-100 d-flex flex-column" }
const _hoisted_11 = { class: "list-group overflow-auto" }
const _hoisted_12 = ["active", "onClick"]
const _hoisted_13 = { class: "text-truncate" }
const _hoisted_14 = ["onClick"]
const _hoisted_15 = /*#__PURE__*/_createElementVNode("span", { "aria-hidden": "true" }, "×", -1)
const _hoisted_16 = [
  _hoisted_15
]
const _hoisted_17 = {
  key: 1,
  class: "card-body p-1"
}
const _hoisted_18 = { class: "d-flex align-items-center justify-content-center h-100" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h5", _hoisted_3, _toDisplayString(_ctx.t('filelist.header.text')), 1),
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _createElementVNode("ul", _hoisted_6, [
          _createElementVNode("li", {
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.getImageFromFilePicker && _ctx.getImageFromFilePicker(...args)))
          }, [
            _createElementVNode("a", _hoisted_7, _toDisplayString(_ctx.t('filelist.upload.from-device')), 1)
          ]),
          _createElementVNode("li", {
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.getImageFromClipboard && _ctx.getImageFromClipboard(...args)))
          }, [
            _createElementVNode("a", _hoisted_8, _toDisplayString(_ctx.t('filelist.upload.from-clipboard')), 1)
          ])
        ])
      ])
    ]),
    (_ctx.fileList.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
          _createElementVNode("form", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.fileList, (file, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: index,
                  class: "list-group-item d-flex justify-content-between align-items-center p-1 list-group-item-light",
                  active: _ctx.store.state.showFileIndex === index,
                  onClick: ($event: any) => (_ctx.store.commit('showFile', index))
                }, [
                  _createElementVNode("span", _hoisted_13, _toDisplayString(index + 1) + " - " + _toDisplayString(file.name), 1),
                  _createElementVNode("button", {
                    "aria-label": "Close",
                    type: "button",
                    class: "btn close btn-secondary",
                    onClick: _withModifiers(($event: any) => (_ctx.store.dispatch('deleteFile', index)), ["stop"])
                  }, _hoisted_16, 8, _hoisted_14)
                ], 8, _hoisted_12))
              }), 128))
            ])
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_17, [
          _createElementVNode("div", _hoisted_18, [
            _createElementVNode("p", null, _toDisplayString(_ctx.t('filelist.notice.emptylist')), 1)
          ])
        ]))
  ]))
}